/** The offer's own payment options; "OTHER" carries its words in the note. */
export type OfferPaymentTerms = "ADVANCE_PAYMENT" | "BY_AGREEMENT" | "VALUTA" | "OTHER";

export type OfferPayment = { terms: OfferPaymentTerms; days: number | null; note: string | null };

/**
 * The offer's payment option for a payment term as the ERP names it, the way a contract carries it: an advance in
 * full is the offer's advance, "by agreement" its "by agreement", a number of days its deferred payment of those days
 * ("30 days from the Invoice date", "Odlozeno do 30 dana od dana isporuke"). Only what is none of these, such as an
 * advance in part or "Date of loading", keeps its own words.
 */
export function offerPaymentFromErp(name: string): OfferPayment {
  const text = name.trim();
  const s = text.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  const advance = /avans|advance|prepayment|predujam/.test(s);
  const percents = [...s.matchAll(/(\d{1,3})\s*%/g)].map((m) => Number(m[1]));
  if (advance) {
    return percents.every((p) => p === 100)
      ? { terms: "ADVANCE_PAYMENT", days: null, note: null }
      : { terms: "OTHER", days: null, note: text };
  }
  if (/po dogovoru|by agreement|as agreed/.test(s)) return { terms: "BY_AGREEMENT", days: null, note: null };
  const days = s.match(/(\d{1,3})\s*(?:dana|dan|days|day)\b/);
  if (days) return { terms: "VALUTA", days: Number(days[1]), note: null };
  return { terms: "OTHER", days: null, note: text };
}
